import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';

export const cookieBannerClickEvent = () => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.COOKIE_BANNER_CLICK,
  });
};
